import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { FAQS } from '../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="w-full bg-white px-3 py-6 sm:px-5" data-id="element-65" data-mp="1lbisipaq7vqv">
      <div className="mx-auto max-w-2xl" data-id="element-66" data-mp="1gcpf0wvfw4qp">
        <h2 id="faq-title" className="text-center font-head text-2xl uppercase leading-none text-navy sm:text-4xl" data-id="element-67" data-mp="1gdqpaz4msn7d">
          Frequently Asked Questions
        </h2>

        <div className="mt-2.5 space-y-1" data-id="element-68" data-mp="291mku0igs92k">
          {FAQS.map((item, index) => {
          const isOpen = open === index;
          return <div key={item.q} className="overflow-hidden rounded-lg border border-line bg-soft" data-id="element-69" data-mp="2418o3embclju" data-mpi={index}>
                <h3 data-id="element-70" data-mp="1z25int2f8dbc">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left font-head text-[12px] uppercase leading-tight text-navy sm:text-[15px]" data-id="element-71" data-mp="1z2xbwx8jpyyg">
                    {item.q}
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-green transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-72" data-mp="pih9wa4fndv9" />
                  </button>
                </h3>
                {isOpen && <p className="border-t border-line bg-white px-3 py-2 text-[12px] leading-snug text-muted sm:text-[13px]" data-id="element-73" data-mp="fm4f18x5ityx">
                    {item.a}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}